import React from "react";
import { useSelector } from "react-redux";
import BalanceInformation from "../BalanceInformation/BalanceInformation";
import BetSlipDesktop from "../BetSlipDesktop/BetSlipDesktop";
import EditStakesPopUp from "./EditStakesPopUp/EditStakesPopUp";


const BetInfoPanel = () => {
    const auth = useSelector(state => state.auth);
    const isOpenEditStakePopup = useSelector((state) => state.editStakesPopUp.isOpen);
    const width = window.innerWidth;


  return (
    <div
      title="Menu 2"
      id="rightDeskSideBar"
      className="hidden lg:flex p-2 overflow-y-auto no-scrollbar z-10 w-[26%] h-[calc(100dvh-120px)] sticky top-[54px] lg:top-[110px]"
    >
        <div className=" flex p-2 overflow-x-hidden relative no-scrollbar border flex-col w-full rounded-lg bg-bg_Quaternary-side ">
            
          {auth&& <BalanceInformation />}

          <BetSlipDesktop />

          {(!!isOpenEditStakePopup && width>=1024)&&
            <EditStakesPopUp open={isOpenEditStakePopup} />
          }
            
            

        </div>
    </div>
  );
};

export default BetInfoPanel;
